import React from "react";

function Carte({ canvas, removeCarte }) {
    function handleClick(e) {
        e.preventDefault();
        removeCarte();
    }

    return (
        <div className="card p-0">
            <img
                className="img-fluid m-0"
                src={canvas.toDataURL("image/png")}
            />
            <button
                className="btn btn-danger position-absolute bottom-0 end-0"
                onClick={handleClick}
            >
                X
            </button>
        </div>
    );
}
export default Carte;
